import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useMyAuth } from '../../context/MyAuthContext';

const ROLE_LEVEL = { client: 0, editeur: 1, manager: 2, admin: 3, superadmin: 4 };

export default function RequireAuth({ children, minRole = 'client' }) {
  const { user, loading } = useMyAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0d0f14] flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-[#0099D6] animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/my" replace />;
  }

  const userLevel = ROLE_LEVEL[user.role] ?? 0;
  const requiredLevel = ROLE_LEVEL[minRole] ?? 0;

  if (userLevel < requiredLevel) {
    return <Navigate to="/my/dashboard" replace />;
  }

  return children;
}
